import loaderImg from '../../../assets/NeatixLogo/LoaderNTX.gif';

const NeatixLoader = ({ loading }) => {
  if (!loading) return null;

  return (
    <>
      <div
        className='loader-container'
        style={{
          zIndex: 1000
        }}
      >
        <div className='loader'>
          <img
            src={loaderImg}
            width='100'
            height='100'
            alt='جارٍ التحميل...'
            style={{ objectFit: 'contain' }}
          />
        </div>
      </div>

      <style>
        {`

            .loader-container{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #0000004a;
    
  }
  .loader{
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
  }
          `}
      </style>
    </>
  );
};

export default NeatixLoader;
